import React, { useState } from 'react';
import { resetPassword, confirmResetPassword } from '../auth';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';

export default function ForgotPasswordPage() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleRequestCode(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await resetPassword({ username: email });
      setStep(2);
    } catch (err) {
      setError(err.message || 'Failed to send reset code');
    } finally {
      setLoading(false);
    }
  }

  async function handleConfirm(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await confirmResetPassword({ username: email, confirmationCode: code, newPassword });
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3 }}>
      <Typography variant="h5" mb={3}>{t('forgotPassword.title')}</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {step === 1 && (
        <Box component="form" onSubmit={handleRequestCode}>
          <TextField label={t('forgotPassword.email')} type="email" fullWidth required
            value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 3 }} />
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? t('forgotPassword.sendingCode') : t('forgotPassword.sendCode')}
          </Button>
        </Box>
      )}

      {step === 2 && (
        <Box component="form" onSubmit={handleConfirm}>
          <Typography variant="body2" mb={2} color="text.secondary">
            {t('forgotPassword.subtitle', { email })}
          </Typography>
          <TextField label={t('forgotPassword.resetCode')} fullWidth required
            value={code} onChange={e => setCode(e.target.value)} sx={{ mb: 2 }} />
          <TextField label={t('forgotPassword.newPassword')} type="password" fullWidth required
            value={newPassword} onChange={e => setNewPassword(e.target.value)} sx={{ mb: 3 }} />
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? t('forgotPassword.settingPassword') : t('forgotPassword.setPassword')}
          </Button>
        </Box>
      )}

      <Box sx={{ mt: 2 }}>
        <Link to="/login">{t('forgotPassword.backToSignIn')}</Link>
      </Box>
    </Box>
  );
}
